<template>
    <div
        v-for="(placement, placementIndex) in visiblePlacements"
        :key="placement.code"
        :class="{
            'mt-4': placementIndex > 0,
        }"
    >
        <step-options-standard-buttons
            v-if="placement.groupType === 'standard-buttons'"
            :placement="placement"
        />

        <step-options-material-buttons
            v-if="placement.groupType === 'material-colors'"
            :placement="placement"
        />
    </div>
</template>

<script>
    import StepOptionsStandardButtons from './StepOptionsStandardButtons.vue';
    import StepOptionsMaterialButtons from './StepOptionsMaterialButtons.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            StepOptionsMaterialButtons,
            StepOptionsStandardButtons,
        },

        props: {
            itemData: {
                type: Object,
                required: true,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            visiblePlacements() {
                const placements = this.customizerStore.visiblePlacementsByGroup[this.itemData.code] ?? [];

                const list = placements.map((placement) => {
                    const selected = this.viewController.selectedAtPlacement(placement.code);

                    // Add extra properties to each placement:
                    // - a code of the currently selected component.
                    return {
                        selectedValue: selected ? selected.code : null,
                        selectedName: selected ? this.viewController.componentNames(selected).join(' ') : null,
                        groupType: placement.custom?.['fj-group-type'],
                        ...placement,
                    };
                });

                return list;
            },
        },
    };
</script>
